import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '@components/components.module';
import { CallCardComponent } from './components/call-card/call-card.component';
import { ServicesModalComponent } from './components/call-card/services-modal.component';
import { SipLoginCardComponent } from './components/sip-login-card/sip-login-card.component';
import { CallUserComponent } from './components/call-user/call-user.component';
import { CallDestinationComponent } from './components/call-destination/call-destination.component';
import { CallReserveComponent } from './components/call-reserve/call-reserve.component';
import { CallDetailsComponent } from './components/call-details/call-details.component';
import { CallAssignComponent } from './components/call-assign/call-assign.component';
import { CallMapComponent } from './components/call-map/call-map.component';
import { CallServicesComponent } from './components/call-services/call-services.component';
import { CallAllServicesComponent } from './components/call-all-services/call-all-services.component';
import { CreatedServiceComponent } from './components/created-service/created-service.component';

@NgModule({
  declarations: [
    CallCardComponent,
    ServicesModalComponent,
    SipLoginCardComponent,
    CallUserComponent,
    CallDestinationComponent,
    CallReserveComponent,
    CallDetailsComponent,
    CallAssignComponent,
    CallServicesComponent,
    CallAllServicesComponent,
    CallMapComponent,
    CreatedServiceComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    ComponentsModule
  ],
  exports: [
    CallCardComponent,
    SipLoginCardComponent,
    CallUserComponent,
    CallDestinationComponent,
    CallReserveComponent,
    CallDetailsComponent,
    CallAssignComponent,
    CallServicesComponent,
    CallAllServicesComponent,
    CallMapComponent,
    CreatedServiceComponent
  ]
})
export class SipModule { }
